(function () {
  var STORAGE_KEY = 'fh_active_discount';

  // Codes powered by our per-product Discount Function (rendered from the
  // $app:function_discount_codes shop metafield). For these, each product shows
  // its OWN discount (data-fh-discount); all other percentage codes are mirrored
  // uniformly across the shop, as before.
  function fnCodes() {
    var list = window.FH_FN_CODES || [];
    if (!Array.isArray(list)) return [];
    return list.map(function (c) { return String(c).toUpperCase(); });
  }

  function formatPrice(cents, template) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    return template.replace(/[\d]+[.,][\d]+/, value);
  }

  // Lagerräumung: ein eigener Code, der pro Produkt 25/30/0 % gibt. Er wird
  // vor FH_FN_CODES geprüft, weil er data-fh-sale braucht statt des
  // data-fh-discount, mit dem die übrigen Function-Codes arbeiten.
  function saleCode() {
    var c = window.FH_LAGER_SALE_CODE;
    return c ? String(c).toUpperCase() : null;
  }

  // Der CTA im Aktions-Popup führt über /discount/CODE, und Shopify legt den
  // Code dann als `discount_code`-Cookie ab. Bei noch leerem Warenkorb kennt
  // /cart.js ihn aber nicht — ohne diesen Blick auf den Cookie stünde direkt
  // nach dem Klick weiter der volle Preis da.
  function saleCookieSet(sale) {
    try {
      return document.cookie.split('; ').some(function (c) {
        if (c.indexOf('discount_code=') !== 0) return false;
        return decodeURIComponent(c.slice(14)).toUpperCase() === sale;
      });
    } catch (e) {
      return false;
    }
  }

  // mode: 'sale' = Lagerräumung (use each element's data-fh-sale)
  //       'pp' = per-product (use each element's data-fh-discount)
  //       'flat' = uniform percent for the whole shop
  function applyDiscount(mode, percent) {
    document.querySelectorAll('product-price').forEach(function (el) {
      var container = el.querySelector('[ref="priceContainer"]');
      if (!container) return;

      var saleDiv = container.querySelector('.price__sale');
      var regularDiv = container.querySelector('.price__regular');
      if (!saleDiv || !regularDiv) return;

      // Skip if already showing a real compare-at price from Shopify
      if (!saleDiv.classList.contains('price__hidden')) return;

      var pct;
      if (mode === 'sale') {
        pct = parseFloat(container.getAttribute('data-fh-sale'));
      } else if (mode === 'pp') {
        pct = parseFloat(container.getAttribute('data-fh-discount'));
      } else {
        pct = percent;
      }
      // No discount for this item (e.g. sale item => 0, or no override)
      if (!pct || pct <= 0) return;

      var priceEl = regularDiv.querySelector('.price');
      if (!priceEl) return;

      var priceText = priceEl.textContent.trim();
      var match = priceText.match(/([\d.,]+)/);
      if (!match) return;

      var rawNum = match[1].replace(/\./g, '').replace(',', '.');
      var originalCents = Math.round(parseFloat(rawNum) * 100);
      if (isNaN(originalCents) || originalCents <= 0) return;

      var discountedCents = Math.round(originalCents * (1 - pct / 100));
      var discountedText = formatPrice(discountedCents, priceText);

      regularDiv.classList.add('price__hidden');
      saleDiv.classList.remove('price__hidden');

      var salePriceEl = saleDiv.querySelector('.price-item--sale');
      var compareEl = saleDiv.querySelector('.compare-at-price');
      if (salePriceEl) salePriceEl.textContent = discountedText;
      if (compareEl) compareEl.textContent = priceText;

      var badge = saleDiv.querySelector('.price-discount-badge');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'price-discount-badge';
        saleDiv.appendChild(badge);
      }
      // Mark as JS-injected so clearDiscount() never removes theme-rendered
      // badges for real compare-at prices
      badge.setAttribute('data-js-discount', '');
      badge.textContent = '-' + pct + '%';
    });
  }

  function clearDiscount() {
    sessionStorage.removeItem(STORAGE_KEY);
    document.querySelectorAll('product-price').forEach(function (el) {
      var container = el.querySelector('[ref="priceContainer"]');
      if (!container) return;
      var saleDiv = container.querySelector('.price__sale');
      var regularDiv = container.querySelector('.price__regular');
      if (!saleDiv || !regularDiv) return;

      // Only undo prices we painted ourselves — theme-rendered badges for
      // real compare-at prices carry no data-js-discount attribute
      var badge = saleDiv.querySelector('.price-discount-badge[data-js-discount]');
      if (badge) {
        saleDiv.classList.add('price__hidden');
        regularDiv.classList.remove('price__hidden');
        badge.remove();
      }
    });
  }

  function applyStored() {
    var stored = sessionStorage.getItem(STORAGE_KEY);
    if (!stored) return false;
    try {
      var s = JSON.parse(stored);
      if (s && s.mode) { applyDiscount(s.mode, s.percent || 0); return true; }
    } catch (e) {}
    return false;
  }

  function processCart(cart) {
    var codes = fnCodes();
    var applicable = (cart.discount_codes || []).filter(function (c) { return c.applicable; });

    // 0) Liegt der Code der Lagerräumung im Warenkorb? Dann gewinnt er — er ist
    //    ohnehin nicht mit anderen Produktrabatt-Codes kombinierbar. Ist der
    //    Korb noch leer, zählt ersatzweise der Cookie: der Kunde hat den Code
    //    gerade über den Popup-CTA aktiviert und soll das auch sehen.
    var sale = saleCode();
    var saleOn = sale && (
      applicable.some(function (c) { return String(c.code).toUpperCase() === sale; }) ||
      (applicable.length === 0 && saleCookieSet(sale))
    );
    if (saleOn) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ mode: 'sale' }));
      applyDiscount('sale', 0);
      return;
    }

    // 1) Is one of OUR per-product function codes applied? -> per-product mode
    var isPerProduct = applicable.some(function (c) {
      return codes.indexOf(String(c.code).toUpperCase()) >= 0;
    });

    // 2) Otherwise look for a uniform percentage discount CODE (not a function
    //    code, not an automatic discount like the Satisbites Mix Box bundle).
    var uniformPercent = 0;
    function consider(app) {
      if (!app || app.type !== 'discount_code' || app.value_type !== 'percentage') return;
      var title = String(app.title || '').toUpperCase();
      if (codes.indexOf(title) >= 0) return; // function code
      if (sale && title === sale) return; // Lagerräumung, hat oben schon gegriffen
      var v = parseFloat(app.value);
      if (v > uniformPercent) uniformPercent = v;
    }
    (cart.cart_level_discount_applications || []).forEach(consider);
    (cart.items || []).forEach(function (item) {
      var allocs = item.line_level_discount_allocations || item.discount_allocations || [];
      allocs.forEach(function (a) { consider(a.discount_application); });
    });

    if (isPerProduct) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ mode: 'pp' }));
      applyDiscount('pp', 0);
    } else if (uniformPercent > 0) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ mode: 'flat', percent: uniformPercent }));
      applyDiscount('flat', uniformPercent);
    } else {
      // A code is applicable but we couldn't read its value yet — reuse stored
      var hasCode = (cart.discount_codes || []).some(function (c) { return c.applicable; });
      if (hasCode && applyStored()) return;
      clearDiscount();
    }
  }

  function checkCartDiscount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(processCart)
      .catch(function () {});
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkCartDiscount);
  } else {
    checkCartDiscount();
  }

  // Re-apply after variant changes (product-price.js replaces the price HTML)
  document.addEventListener('variant:update', function () {
    setTimeout(applyStored, 150);
  });

  // Re-check when discount is applied/removed in cart drawer
  document.addEventListener('discount:update', function () {
    setTimeout(checkCartDiscount, 200);
  });

  // Re-check after cart updates (item added/removed may change discount visibility)
  document.addEventListener('cart:update', function () {
    setTimeout(checkCartDiscount, 200);
  });

  // Watch for lazy-loaded product-price elements (e.g. recommendations, siblings)
  var observer = new MutationObserver(function (mutations) {
    if (!sessionStorage.getItem(STORAGE_KEY)) return;

    var hasNewPrices = false;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.tagName === 'PRODUCT-PRICE' || (node.querySelector && node.querySelector('product-price'))) {
          hasNewPrices = true;
          break;
        }
      }
      if (hasNewPrices) break;
    }

    if (hasNewPrices) applyStored();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
